import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { AthleteEvent } from "@/models";

const state = {
  athleteListEvent: new AthleteEvent(),
  athleteListEvents: [],
  athleteEventsLoading: false,
  athleteEvent: new AthleteEvent(),
  athleteEventLoading: false,
  meta: {}
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
